import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpCacheService } from "../Services/http-cache.service";

@Injectable({ providedIn: 'root' })
export class HttpClientCached {

  constructor(
    private http: HttpClient,
    private cache: HttpCacheService
  ) {}

  getCached<T>(
    url: string,
    options?: {
      params?: HttpParams;
      headers?: HttpHeaders;
    }
  ): Observable<T> {

    const key = url + JSON.stringify(options?.params ?? {});

    return this.cache.get(
      key,
      this.http.get<T>(url, {
        ...options,
        observe: 'response'
      })
    );
  }
  clearCache(key?: string) {
    this.cache.clear(key);
  }
}
